import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDeliveryOrderFulfillmentMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  container_station_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  event_id: Types.Scalars['ID'];
  timestamp?: Types.InputMaybe<Types.Scalars['String']>;
  item_location_id: Types.Scalars['ID'];
  manual_amounts: Array<Types.ContainerTypeAmountInput> | Types.ContainerTypeAmountInput;
  container_ids: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  type_override?: Types.InputMaybe<Types.OrderFulfillmentType>;
}>;


export type CreateDeliveryOrderFulfillmentMutation = { __typename?: 'Mutation', createDeliveryOrderFulfillment: { __typename?: 'CreateOrderFulfillmentResult', id: string } };


export const CreateDeliveryOrderFulfillmentDocument = gql`
    mutation CreateDeliveryOrderFulfillment($event_account_id: ID!, $container_station_ids: [ID!]!, $event_id: ID!, $timestamp: String, $item_location_id: ID!, $manual_amounts: [ContainerTypeAmountInput!]!, $container_ids: [ID!]!, $type_override: OrderFulfillmentType) {
  createDeliveryOrderFulfillment(
    event_account_id: $event_account_id
    container_station_ids: $container_station_ids
    event_id: $event_id
    timestamp: $timestamp
    item_location_id: $item_location_id
    manual_amounts: $manual_amounts
    container_ids: $container_ids
    type_override: $type_override
  ) {
    id
  }
}
    `;
export type CreateDeliveryOrderFulfillmentMutationFn = Apollo.MutationFunction<CreateDeliveryOrderFulfillmentMutation, CreateDeliveryOrderFulfillmentMutationVariables>;

/**
 * __useCreateDeliveryOrderFulfillmentMutation__
 *
 * To run a mutation, you first call `useCreateDeliveryOrderFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeliveryOrderFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeliveryOrderFulfillmentMutation, { data, loading, error }] = useCreateDeliveryOrderFulfillmentMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      container_station_ids: // value for 'container_station_ids'
 *      event_id: // value for 'event_id'
 *      timestamp: // value for 'timestamp'
 *      item_location_id: // value for 'item_location_id'
 *      manual_amounts: // value for 'manual_amounts'
 *      container_ids: // value for 'container_ids'
 *      type_override: // value for 'type_override'
 *   },
 * });
 */
export function useCreateDeliveryOrderFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeliveryOrderFulfillmentMutation, CreateDeliveryOrderFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeliveryOrderFulfillmentMutation, CreateDeliveryOrderFulfillmentMutationVariables>(CreateDeliveryOrderFulfillmentDocument, options);
      }
export type CreateDeliveryOrderFulfillmentMutationHookResult = ReturnType<typeof useCreateDeliveryOrderFulfillmentMutation>;
export type CreateDeliveryOrderFulfillmentMutationResult = Apollo.MutationResult<CreateDeliveryOrderFulfillmentMutation>;
export type CreateDeliveryOrderFulfillmentMutationOptions = Apollo.BaseMutationOptions<CreateDeliveryOrderFulfillmentMutation, CreateDeliveryOrderFulfillmentMutationVariables>;